export default "__VITE_ASSET__BoDu0B$C__"